import axios from "api/axios";

export const getUsers = (per_page, page) => {
  return axios.get(`/admin/user?per_page=${per_page}&page=${page}`).then((response) => response.data);
};

export const getUser = (id) => {
  return axios.get(`/admin/user/${id}/edit`).then((response) => response.data);
};
